module.exports = __webpack_public_path__ + "media/click.3272caa7.mp3";